/* eslint-disable */
import React from 'react'
import config from '../config'
import storage from '../storage'
import { showToast } from '../Toast'
import { Intent } from '@blueprintjs/core'
import manifestLabel from './labels/manifest2'
import code39Label from './labels/code39'
import code128Label from './labels/code128'
import inventoryLocationLabel from './labels/inventory_location'
import './initializeDymo'

export const PRINTER_STORAGE_KEY = 'printer'

function getPrinterName() {
  return storage.getFromStorage(PRINTER_STORAGE_KEY)
}

function alertNoPrinter() {
  showToast(<a href="/settings/printing">No printer found! Click here to add one.</a>, Intent.WARNING)
}

export default function Printer(barcode, title, inventoryLocationName) {
  const printer = getPrinterName()
  if (!printer) {
    return alertNoPrinter()
  }

  const label =
    config.LABEL_PRINT_TYPE === 'sku'
      ? configureCode128Label(barcode)
      : configureCode39Label(barcode, title, inventoryLocationName)
  label.print(printer)
}

export async function PrinterAsyncManifest(barcodeTop, barcodeBottom) {
  const printer = getPrinterName()
  if (!printer) {
    return alertNoPrinter()
  }

  const label =
    config.LABEL_PRINT_TYPE === 'sku'
      ? configureCode128Label(barcodeBottom)
      : configureCode39ManifestLabel(barcodeTop, barcodeBottom)

  await label.printAsync(printer)
}

export async function PrinterAsyncInventoryLocation(barcode, text) {
  const printer = getPrinterName()
  if (!printer) {
    alertNoPrinter()
    return null
  }
  const label = configureCode128InventoryLocationLabel(barcode, text)
  await label.printAsync(printer)
  return true
}

export async function getPrinters() {
  return dymo.label.framework.getLabelWriterPrintersAsync()
}

function configureCode128Label(barcode) {
  const label = dymo.label.framework.openLabelXml(code128Label())
  label.setObjectText('Barcode', barcode)
  return label
}

function configureCode39Label(barcode, title, inventoryLocationName) {
  const label = dymo.label.framework.openLabelXml(code39Label())
  label.setObjectText('Barcode', barcode)
  label.setObjectText('Text', title)
  label.setObjectText('Shelf', `Location: ${inventoryLocationName}`)
  return label
}

function configureCode39ManifestLabel(barcodeTop, barcodeBottom) {
  const label = dymo.label.framework.openLabelXml(manifestLabel())
  label.setObjectText('BARCODE 1', barcodeTop)
  label.setObjectText('BARCODE 2', barcodeBottom)
  return label
}

function configureCode128InventoryLocationLabel(barcode, text) {
  const label = dymo.label.framework.openLabelXml(inventoryLocationLabel())
  label.setObjectText('Barcode', barcode)
  label.setObjectText('Text', text)
  return label
}
